import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { getPopulationDensityPanelDisplay } from '../../../utils/populationDensityDisplay';
import {
  LOT_INFO_FIELD_ROW_SX,
  LotInfoMetricIndicator,
  lotInfoFieldLabelLayoutSx,
  lotInfoFieldValueSx,
} from './formBlockUi';

const TOOLTIP_SLOT_PROPS = {
  tooltip: {
    sx: {
      textAlign: 'center',
      maxWidth: 300,
      whiteSpace: 'normal',
      fontSize: '12px',
      lineHeight: 1.4,
    },
  },
};

/**
 * Fila de densidad poblacional (`population_density`). Se usa dentro de LotEntornoUrbanoSection.
 */
const LotDensidadPoblacionalSection = ({ populationDensity = null }) => {
  const display = getPopulationDensityPanelDisplay(populationDensity);

  return (
    <Box sx={LOT_INFO_FIELD_ROW_SX}>
      <Typography sx={lotInfoFieldLabelLayoutSx()}>
        Densidad poblacional
      </Typography>

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Tooltip
          title={display.tooltip}
          placement="top"
          arrow
          slotProps={TOOLTIP_SLOT_PROPS}
        >
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              gap: '2px',
              maxWidth: '100%',
              cursor: 'help',
            }}
          >
            <Box
              component="span"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: '7px',
                maxWidth: '100%',
              }}
            >
              <LotInfoMetricIndicator color={display.accentColor} />
              <Typography
                component="span"
                sx={lotInfoFieldValueSx({ monospace: true })}
              >
                {display.valueLabel}
              </Typography>
            </Box>
          </Box>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default LotDensidadPoblacionalSection;
